"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationReport',
  data: function data() {
    return {
      loading: false,
      drawerVisible: false,
      detail: null,
      dateRange: [],
      commentContent: '',
      commenting: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        projectId: '',
        reportType: '',
        status: '',
        visibility: ''
      },
      tableData: {
        data: [],
        total: 0
      },
      typeOptions: [{
        value: 'daily',
        label: '工地日记'
      }, {
        value: 'progress',
        label: '进度汇报'
      }, {
        value: 'quality',
        label: '质量汇报'
      }, {
        value: 'safety',
        label: '安全汇报'
      }, {
        value: 'briefing',
        label: '施工交底'
      }, {
        value: 'inspection',
        label: '现场巡检'
      }, {
        value: 'signoff',
        label: '到场签收'
      }, {
        value: 'received',
        label: '材料到货'
      }, {
        value: 'delivery',
        label: '主材交付'
      }, {
        value: 'acceptance',
        label: '验收记录'
      }, {
        value: 'service',
        label: '服务记录'
      }],
      typeTag: {
        daily: 'warning',
        progress: 'success',
        quality: 'primary',
        safety: 'danger',
        briefing: 'info',
        inspection: 'primary',
        signoff: 'success',
        received: 'warning',
        delivery: 'warning',
        acceptance: 'success',
        service: 'info'
      },
      statusTag: {
        draft: 'warning',
        published: 'success',
        hidden: 'danger'
      }
    };
  },
  computed: {
    publishedCount: function publishedCount() {
      return this.tableData.data.filter(function (item) {
        return item.report.status === 'published';
      }).length;
    },
    draftCount: function draftCount() {
      return this.tableData.data.filter(function (item) {
        return item.report.status === 'draft';
      }).length;
    },
    hiddenCount: function hiddenCount() {
      return this.tableData.data.filter(function (item) {
        return item.report.status === 'hidden';
      }).length;
    },
    interactionCount: function interactionCount() {
      return this.tableData.data.reduce(function (sum, item) {
        return sum + Number(item.report.commentCount || 0);
      }, 0);
    },
    projectOptions: function projectOptions() {
      var values = {};
      this.tableData.data.forEach(function (item) {
        if (item.project) values[item.project.id] = item.project.projectName;
      });
      return Object.keys(values).map(function (id) {
        return {
          id: Number(id),
          name: values[id]
        };
      });
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    typeText: function typeText(value) {
      var item = this.typeOptions.find(function (option) {
        return option.value === value;
      });
      return item ? item.label : value;
    },
    statusText: function statusText(value) {
      return {
        draft: '草稿',
        published: '已发布',
        hidden: '已屏蔽'
      }[value] || value;
    },
    visibilityText: function visibilityText(value) {
      return {
        internal: '内部',
        project: '项目',
        public: '公开'
      }[value] || value;
    },
    roleText: function roleText(value) {
      return {
        owner: '装企负责人',
        foreman: '工长',
        supervisor: '监理',
        designer: '设计师',
        coordinator: '协调人',
        customer: '业主',
        merchant_admin: '后台管理员'
      }[value] || value;
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      var params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
        dateLimit: this.dateRange && this.dateRange.length ? this.dateRange.join(',') : ''
      });
      (0, _decoration.decorationReportListApi)(params).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        projectId: '',
        reportType: '',
        status: '',
        visibility: ''
      };
      this.dateRange = [];
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    openDetail: function () {
      var _openDetail = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(row) {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _decoration.decorationReportDetailApi)(row.report.id);
            case 1:
              this.detail = _context.v;
              this.drawerVisible = true;
              this.commentContent = '';
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t.message || '详情加载失败');
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function openDetail(_x) {
        return _openDetail.apply(this, arguments);
      }
      return openDetail;
    }(),
    sendComment: function () {
      var _sendComment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.commentContent) {
                _context2.n = 1;
                break;
              }
              this.$message.warning('请输入评论内容');
              return _context2.a(2);
            case 1:
              this.commenting = true;
              _context2.p = 2;
              _context2.n = 3;
              return (0, _decoration.decorationReportCommentApi)(this.detail.report.id, {
                content: this.commentContent,
                mentionedMemberIds: []
              });
            case 3:
              this.detail = _context2.v;
              this.commentContent = '';
              _context2.n = 4;
              return this.getList();
            case 4:
              this.$message.success('后台评论已同步');
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
              this.$message.error(_t2.message || '评论失败');
            case 6:
              _context2.p = 6;
              this.commenting = false;
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 5, 6, 7]]);
      }));
      function sendComment() {
        return _sendComment.apply(this, arguments);
      }
      return sendComment;
    }(),
    confirmAction: function confirmAction(row, action) {
      var _this2 = this;
      var labels = {
        hide: '屏蔽',
        restore: '恢复',
        delete: '删除'
      };
      this.$confirm("".concat(labels[action], "\u201C").concat(row.report.title, "\u201D\uFF1F"), '内容治理', {
        type: action === 'delete' ? 'warning' : 'info'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var result, _t3;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return (0, _decoration.decorationReportActionApi)(row.report.id, {
                action: action
              });
            case 1:
              result = _context3.v;
              if (action === 'delete') {
                _this2.drawerVisible = false;
                _this2.detail = null;
              } else if (_this2.detail && _this2.detail.report.id === row.report.id) _this2.detail = result;
              _context3.n = 2;
              return _this2.getList();
            case 2:
              _this2.$message.success("".concat(labels[action], "\u6210\u529F"));
              _context3.n = 4;
              break;
            case 3:
              _context3.p = 3;
              _t3 = _context3.v;
              _this2.$message.error(_t3.message || '操作失败');
            case 4:
              return _context3.a(2);
          }
        }, _callee3, null, [[0, 3]]);
      }))).catch(function () {});
    }
  }
};